import {RSAA} from "redux-api-middleware";
import {fetchGameInfoActionTeamDetails} from "../Core/myResultsActions";

export const TEAM_DETAILS_INIT = 'TEAM_DETAILS_INIT';
export const TEAM_DETAILS_SET_TEAM = 'TEAM_DETAILS_SET_TEAM';
export const TEAM_DETAILS_LOADING = 'TEAM_DETAILS_LOADING';
export const TEAM_DETAILS_NOT_SUPPORTED = 'TEAM_DETAILS_NOT_SUPPORTED';
export const YEAR_GAMES_STARTLIST = 'YEAR_GAMES_STARTLIST';

export const teamDetailsInitAction = (ownTeams, stages, columns, perStage, separatePerStage, achievements) => ({
    type: TEAM_DETAILS_INIT,
    payload: {
        ownTeams, stages, perStage, columns, separatePerStage, achievements
    }
});



export const teamDetailsSetTeamAction = (team) => ({
    type: TEAM_DETAILS_SET_TEAM,
    payload: team
});
export const teamDetailsNotSupportedAction = (team) => ({
    type: TEAM_DETAILS_NOT_SUPPORTED,
    payload: team
});
 
export const yearGamesStartListAction = (yearGamesData, supermatchData) => ({
    type: YEAR_GAMES_STARTLIST,
    payload: {
        yearGamesData, supermatchData
    }
});

export const setLoadingAction = () => ({
    type: TEAM_DETAILS_LOADING
});

export const loadTeamDetails = (gameId, teamId) => (dispatch, getState) => {
    dispatch(setLoadingAction());
    let currentGame = getState().games.current;

    // if (!currentGame || currentGame.id != gameId) { 
        dispatch(fetchGameInfoActionTeamDetails({id: gameId}))
            .then(() => dispatch(yearGamesStartListDetails()))
            .then(() => dispatch(openTeamDetails(teamId)));

    // } else {
    //     dispatch(openTeamDetails(teamId))
    // }

};



export const openTeamDetails = (teamId) => (dispatch, getStore) => {
    dispatch({
        [RSAA]: {
            endpoint: `/api/v1/game/${getStore().games.current.id}/team/${teamId}/details`,
            method: 'GET',
            credentials: 'same-origin',
            types: [
                'REQUEST',
                {
                    type: 'SUCCESS',
                    payload: (action, state, res) => (
                        res.json().then(
                            json => { 
                                if (json.data.notSupported) {
                                    dispatch(teamDetailsNotSupportedAction(
                                        json.data
                                    ));
                                    return;
                                }
                                const state = getStore();

                                const entriesOwn =
                                    (state.ranking.entriesOwn
                                    && state.ranking.entriesOwn.map(e => ({
                                        id: e.zweelerTeamId,
                                        name: e.teamName
                                    }))
                                    || null);


                                let classifications = false;
                                if (json.relationships.perStage) {
                                    classifications = state.classifications.stages;
                                } else if (json.relationships.separatePerStage) {
                                    classifications = [...state.classifications.general, ...state.classifications.stages];
                                }

                                const dispatchResult = dispatch(teamDetailsInitAction(
                                    entriesOwn,
                                    classifications,
                                    json.relationships.columns,
                                    json.relationships.perStage,
                                    json.relationships.separatePerStage,
                                    json.relationships.achievements
                                  ));
                                  
                                dispatch(teamDetailsSetTeamAction(
                                    json.data
                                ));
                            }
                        )
                    )
                },
                'FAILURE',
            ]
        }
    });
};

/**
 *
 * @param teamId
 * @param [classificationId]
 */
export const fetchTeamDetails = (teamId, classificationId) => (dispatch, getStore) => dispatch({
    [RSAA]: {
        endpoint: `/api/v1/game/${getStore().games.current.id}/team/${teamId}/details/classification/${classificationId}`,
        method: 'GET',
        credentials: 'same-origin',
        types: [
            'REQUEST',
            {
                type: 'SUCCESS',
                payload: (action, state, res) => (
                    res.json().then(
                        json => {
                            dispatch(teamDetailsSetTeamAction(
                                json.data
                            ));
                        }
                    )
                )
            },
            'FAILURE'
        ]
    }
});


export const yearGamesStartListDetails = () => (dispatch, getStore) => dispatch({
    [RSAA]: {
        endpoint: `/api/v1/game/${getStore().games.current.id}/yearGamesStartlist`,
        method: 'GET',
        credentials: 'same-origin',
        types: [
            'REQUEST',
            {
                type: 'SUCCESS',
                payload: (action, state, res) => (
                    res.json().then(
                        json => {
                            dispatch(yearGamesStartListAction(
                                json.Startlists.yearGamesData,
                                json.Startlists.Supermatch
                            ));
                        }
                    )
                )
            },
            'FAILURE'
        ]
    }
});
